
import React, { lazy, Suspense } from 'react';

import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  Routes,

  createHashRouter,
} from "react-router-dom";

// import IndexComponent from './app-site/components/index-component/index.component';
// import RegistroComponent from './app-site/components/registro-component/registro.component';
// import DownloadComponent from './app-site/components/download-component/download-component';

import AlterarSenhaComponent from './components/painel-component/altera-senha/altera-senha.component';
import MainComponent from './components/main-component/main.component';
import { PacotesPontosComponent } from './components/loja-component/pacotes-pontos-component/pacotes-pontos.component';
import { MinhasComprasComponent } from './components/loja-component/minhas-compras-component/minhas-compras.component';

const IndexComponent = React.lazy(() => import('./components/index-component/index.component'));
const RegistroComponent = React.lazy(() => import('./components/registro-component/registro.component'));
const DownloadComponent = React.lazy(() => import('./components/download-component/download-component'));
const LojaComponent = React.lazy(() => import('./components/loja-component/loja-component'));
const PainelUsuarioComponent = React.lazy(() => import('./components/painel-component/painel.component'));
const MeusPersonagensComponent = React.lazy(() => import('./components/painel-component/meus-personagens/meuspersonagens-component'));
const RecuperarSenhaComponent = React.lazy(() => import('./components/recuperasenha-component/recuperasenha.component'));
const PagamentoSucessoComponent = React.lazy(() => import('./components/pagamento-component/pagamento-sucesso.component'));
const PagamentoPendenteComponent = React.lazy(() => import('./components/pagamento-component/pagamento-pendente.component'));
const PagamentoFalhouComponent = React.lazy(() => import('./components/pagamento-component/pagamento-falhou.component'));

export const router = createHashRouter([
  {
    path: '/',
    element: <MainComponent />,
    children: [
      { path: '/', element: <IndexComponent /> },
      { path: 'registro', element: <RegistroComponent /> },
      { path: 'download', element: <DownloadComponent /> },
      { path: 'loja', element: <LojaComponent /> },
      { path: 'painel', element: <PainelUsuarioComponent /> },
      { path: 'painel/recuperar-senha', element: <RecuperarSenhaComponent /> },
      { path: 'painel/altera-senha', element: <AlterarSenhaComponent /> },
      { path: 'painel/meus-personagens', element: <MeusPersonagensComponent /> },
      { path: 'pagamento-efetuado-com-sucesso', element: <PagamentoSucessoComponent /> },
      { path: 'pagamento-pendente', element: <PagamentoPendenteComponent /> },
      { path: 'pagamento-falhou', element: <PagamentoFalhouComponent /> },
      { path: 'loja/pacotes', element: <PacotesPontosComponent /> },
      { path: 'loja/minhas-compras', element: <MinhasComprasComponent /> }
    ],
  },
]);